import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const publicRoutes = ["forgot-password", "reset-password", "invitation"];

const useRouteStatus = () => {
  const { pathname } = useLocation();

  const [isPublicRoute, setIsPublicRoute] = useState<boolean>(false);

  useEffect(() => {
    const isPublic =
      pathname === "/" ||
      !!publicRoutes.find((route) => pathname.includes(route));

    setIsPublicRoute(isPublic);
  }, [pathname]);

  return { isPublicRoute };
};

export default useRouteStatus;
